export const build = {"tag":"v1.0.6","hash":"1b45c657","time":"261103.0824"}